var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/**
 * If original query doesn't return enough results then fallback query is run added to results
 *
 * @category Modifier
 * @param func
 * @returns
 */
export function fallback(func, options) {
    var _a;
    if (((_a = func.queries) === null || _a === void 0 ? void 0 : _a.length) !== 1) {
        throw new Error("Fallback modifier can only be applied to single query");
    }
    const fallbackQuery = func.queries[0];
    fallbackQuery.isFallbackQuery = true;
    return {
        klevuModifierId: "fallback",
        modifyAfter: (queries) => __awaiter(this, void 0, void 0, function* () {
            const copy = Array.from(queries);
            for (const query of copy) {
                if (!query.id || query.isFallbackQuery === true) {
                    continue;
                }
                fallbackQuery.id = `${query.id}-fallback`;
                if (!query.settings) {
                    query.settings = {};
                }
                query.settings.fallbackQueryId = fallbackQuery.id;
                query.settings.fallbackWhenCountLessThan =
                    options === null || options === void 0 ? void 0 : options.runWhenLessThanResults;
                copy.push(fallbackQuery);
            }
            return copy;
        }),
    };
}
